import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import {
	green,
	blue,
	lightgray
} from '../../../utils/constants';
import SearchResults from './searchresults';


const EventSection = {
    marginLeft:'10px'
};
const Events = (props) => {
    const { searchResults } = props;
    let league = [];
    let tournament = [];

    if (searchResults !== undefined && searchResults.length > 0) 
    {
        league = searchResults.filter(evt => evt.eventType === 2);
        tournament = searchResults.filter(evt => evt.eventType === 3);
    }
        return (
            <div sm={12} style={{ backgroundColor:'white',padding:'10px', border:`1px solid ${lightgray}` }}>
                <FormGroup>
                    <h4>
                        {props.timeline}
                    </h4>
                </FormGroup>
                <FormGroup style={EventSection}>
                    <h4 style={{ color:blue, textDecoration:'underline' }}>Leagues</h4>
                    <SearchResults searchResults={league}/>
                </FormGroup>
                <FormGroup style={EventSection}>
                    <h4 style={{ color:green, textDecoration:'underline' }}>Tournaments</h4>
                    <SearchResults searchResults={tournament}/>
                </FormGroup>
            </div>
        );
};
Events.propTypes = {
    timeline:PropTypes.string,
    searchResults:PropTypes.array,
};
export default Events;


// WEBPACK FOOTER //
// ./src/containers/eventsview/components/events.js